<template>
  <div class="opple-title">
    <slot />
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      
    };
  },
};
</script>

<style scoped="scoped" lang="scss">
.opple-title {
  position: relative;
  text-indent: 10px;
  font-size: 16px;
  color: #111;
  
  &:after {
    content: "";
    position: absolute;
    width: 3px;
    height: 16px;
    left: 0;
    top: 4px;
    background-color: #0046aa;
  }
}
</style>
